import { createContext, useContext } from 'react';

/* eslint-disable @typescript-eslint/no-empty-function */
const DialogContext = /*#__PURE__*/createContext({
  closeOnEscape: true,
  draggable: false,
  drawer: {
    open: false,
    toggle: () => {}
  },
  elements: {
    drawer: undefined,
    extra: undefined
  },
  onClose: () => {},
  props: {},
  ref: null,
  showCloseButton: true,
  size: 'sm'
});
const useCurrentDialog = () => {
  return useContext(DialogContext);
};

export { DialogContext, useCurrentDialog };
//# sourceMappingURL=Context.js.map
